import React from "react";

export default function Section3() {
  const reasons = [
    {
      title: "Custom Shopify Store Design",
      description: "Our Shopify designers build branded storefronts tailored to your business, focusing on intuitive navigation, clean layouts, and seamless shopping experiences for Texas ecommerce customers.",
    },
    {
      title: "Shopify Integrations & Automation",
      description: "We connect Shopify with ERPs, CRMs, and marketing platforms to automate workflows, streamline operations, and centralize store management efficiently.",
    },
    {
      title: "Shopify SEO & Conversion Optimization",
      description: "We implement SEO and CRO strategies that improve search visibility, increase product discoverability, and turn traffic into consistent sales growth.",
    },
    {
      title: "Shopify Migration Services",
      description: "We handle migrations from platforms like Magento, WooCommerce, and BigCommerce with zero data loss, minimal downtime, and a smooth transition to Shopify.",
    },
    {
      title: "Shopify Plus Transition",
      description: "We help growing brands upgrade from standard Shopify to Shopify Plus with zero data loss, improved performance, and better handling of high traffic and order volume.",
    },
  ];

  return (
    <div className="w-full Section12">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        {/* Main Heading */}
        <h2 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
            Our Shopify Development Expertise
        </h2>

        {/* Cards container */}
        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {reasons.map((item, index) => (
            <div
              key={index}
              className={`p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%] rounded-[8px] ${
                index % 2 === 0
                  ? "bg-[#E42E35] text-white"
                  : "bg-[#f5f5f5] text-[#373737]"
              }`}
            >
              <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {item.title}
              </h3>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
